var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preferencess"},[_vm._m(0),_c('hr'),_c('FormPreferences',{attrs:{"_preferences":_vm.preferences},on:{"update":_vm.update}}),_c('LoadingComponent',{attrs:{"loading":_vm.loading}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h1',{staticClass:"fw-600 fs-24 mb-0"},[_vm._v("Configurações da Conta")])])])
}]

export { render, staticRenderFns }